import React, { useState } from 'react';
import axios from 'axios';
import Cookies from 'js-cookie';
import './UncoveLogin.css';

const UncoveLogin = ({ onLoginSuccess, onCancel }) => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleEmailChange = (e) => {
        setEmail(e.target.value);
        setError('');
    };

    const handlePasswordChange = (e) => {
        setPassword(e.target.value);
        setError('');
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        setError('');

        try {
            const jwt = Cookies.get('user_token');
            const response = await axios.get('https://unbot.io/api/v1.0/auth/uncove', {
                headers: {
                    Authorization: `Bearer ${jwt}`,
                },
                params: {
                    mail: email,
                    password
                }
            });

            if (response.data.success) {
                onLoginSuccess(response.data.uncoveUsername, response.data.token);
            } else {
                setError(response.data?.error?.message ?? 'Identifiants incorrects');
            }
        } catch (error) {
            if (error.response?.data?.error) {
                setError(error.response.data.error);
            } else {
                setError('Une erreur est survenue lors de la vérification des identifiants');
            }
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="uncove-login-container">

            <h2 className="uncove-login-title">Connexion Uncove</h2>
            
            <form onSubmit={handleSubmit} autoComplete="off">
                <input
                    type="email"
                    name="uncove_email"
                    className="text-input"
                    placeholder="Email Uncove"
                    value={email}
                    onChange={handleEmailChange}
                    autoComplete="off"
                    required
                />

                <input
                    type="password"
                    name="uncove_secret"
                    className="text-input"
                    placeholder="Mot de passe Uncove"
                    value={password}
                    onChange={handlePasswordChange}
                    autoComplete="new-password"
                    required
                />

                {error && <div className="error-message">{error}</div>}

                <div className="uncove-login-actions">
                    <button
                        type="submit"
                        className="uncove-login-primary-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Vérification...' : 'Se connecter'}
                    </button>
                    <button
                        type="button"
                        className="uncove-login-secondary-button"
                        onClick={onCancel}
                    >
                        Annuler
                    </button>
                </div>
            </form>
        </div>
    );
};

export default UncoveLogin;
